import { motion } from "framer-motion";
import "./HeroSection.css";
import heroImage from "../../Images/new_banquet_banner.png";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <div className="hero-container">
      {/* Background */}
      <motion.img
        src={heroImage}
        alt="Banquet Setup"
        className="hero-bg"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 6, ease: "easeOut" }}
      />

      <div className="hero-overlay"></div>

      {/* Content */}
      <div className="hero-content">
        <motion.p
          className="hero-welcome"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Welcome To
        </motion.p>

        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Ganga Kinare <br />
          <span>Banquet</span>
        </motion.h1>

        <motion.p
          className="hero-description"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          Lorem ipsum dolor sit, amet consectetur adipisicing elit.
          Quibusdam maxime praesentium. Why did the scarecrow win an
          award? Because he was outstanding in his field.
        </motion.p>

        <motion.div
          className="hero-buttons"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 1 }}
        >
          <button
            className="btn-primary"
            onClick={() => navigate("/booking")}
          >
            Book Now
          </button>

          <button
            className="btn-secondary"
            onClick={() => {
              const element = document.getElementById("gallery");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
            }}
          >
            Gallery
          </button>
        </motion.div>
      </div>
    </div>
  );
}